var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('van-icon',{attrs:{"name":"bar-chart-o"}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.mes))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }